export default __webpack_public_path__ + "static/media/workcafe-dashboard-1.37a4675e.JPG";